import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './reset.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Main from './components/Pages/Main/Main';
import Greeting from './components/Pages/Greeting/Greeting';
import SmoPage from './components/Pages/SmoPage/SmoPage';
import SmtPage from './components/Pages/Smt/SmtPage';
import HrpPage from './components/Pages/HrpPage/HrpPage';
import RaPage from './components/Pages/RaPage/RaPage';
import ErrorPage from './components/Pages/ErrorPage/ErrorPage';
import DirectionsPage from './components/Pages/DirectionsPage/DirectionsPage';

// aos
import AOS from 'aos';
import 'aos/dist/aos.css';
import PsmPage from './components/Pages/Psm/PsmPage';
import KcmPage from './components/Pages/KcmPage/KcmPage';
import SkeletonPage from './components/Pages/Skeleton/SkeletonPage';
import IsoPage from './components/Pages/IsoPage/IsoPage';
import KoshaMsPage from './components/Pages/KoshaMsPage/KoshaMsPage';
import Layout from './components/UI/Layout';

const hStyle = {
    marginTop: 0,
    marginBottom: '0.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#1e2022',
};

const basicFontColor = '#666';

const letterSpacing = '-1px';

const customTheme = createTheme({
    typography: {
        h1: hStyle,
        h2: hStyle,
        h3: hStyle,
        h4: hStyle,
        h5: hStyle,
        pageTitle: {
            fontSize: '2rem',
            color: '#1e2022',
            fontWeight: 500,
            marginBottom: '1rem',
            letterSpacing: letterSpacing,
            lineHeight: 1.5,
        },
        subTitle: {
            fontSize: '1.625rem',
            color: '#1e2022',
            marginBottom: '1rem',
            fontWeight: 500,
            lineHeight: 1.5,
            letterSpacing: letterSpacing,
        },
        contentTitle: {
            fontSize: '1.2rem',
            color: basicFontColor,
            marginBottom: '0.625rem',
            fontWeight: 500,
            letterSpacing: letterSpacing,
        },
        contentTitleSmall: {
            fontSize: '1rem',
            lineHeight: 1.5,
            color: basicFontColor,
            fontWeight: 500,
        },
        description: {
            fontSize: '1.1rem',
            color: basicFontColor,
            fontWeight: 400,
            lineHeight: 2,
            letterSpacing: letterSpacing,
        },
        description2: {
            fontSize: '1rem',
            color: basicFontColor,
            fontWeight: 400,
            lineHeight: 1.6,
            letterSpacing: letterSpacing,
        },
        descriptionSmall: {
            fontSize: '0.9375rem',
            color: basicFontColor,
            fontWeight: 400,
            lineHeight: 1.6,
            letterSpacing: letterSpacing,
        },
        reference: {
            fontSize: '0.875rem',
            color: basicFontColor,
            lineHeight: 1.5,
            fontWeight: 400,
            letterSpacing: letterSpacing,
        },
    },
    shadows: [
        'none',
        '0 0.375rem 1.5rem 0 rgba(140,152,164,.125)',
        '0 2.75rem 5.5rem -3.5rem rgba(189,197,209,.5), 0 2rem 4rem -2rem rgba(33,50,91,.3)',
    ],
});

const router = createBrowserRouter([
    {
        path: '/',
        element: <Layout />,
        errorElement: <ErrorPage />,
        children: [
            { path: '/', element: <Main /> },
            { path: '/greeting', element: <Greeting /> },
            { path: '/content_01', element: <SmoPage /> },
            { path: '/content_02', element: <SmtPage /> },
            { path: '/content_03', element: <HrpPage /> },
            { path: '/content_04', element: <RaPage /> },
            { path: '/content_05', element: <PsmPage /> },
            { path: '/content_06', element: <KcmPage /> },
            { path: '/content_07', element: <SkeletonPage /> },
            { path: '/content_08', element: <IsoPage /> },
            { path: '/content_09', element: <KoshaMsPage /> },
            { path: '/directions', element: <DirectionsPage /> },
        ],
    },
]);

function App() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true, // 스크롤시 한번만 실행
        });
    });
    return (
        <React.Fragment>
            <ThemeProvider theme={customTheme}>
                <RouterProvider router={router} />
            </ThemeProvider>
        </React.Fragment>
    );
}

export default App;
